package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.px

val FadeInUpKeyframes = Keyframes {
    from {
        Modifier
            .opacity(0)
            .translateY(30.px)
    }
    to {
        Modifier
            .opacity(1)
            .translateY(0.px)
    }
}
